import { render, staticRenderFns } from "./orderEvaluateDetail.vue?vue&type=template&id=1c601da4&scoped=true"
import script from "./orderEvaluateDetail.vue?vue&type=script&lang=js"
export * from "./orderEvaluateDetail.vue?vue&type=script&lang=js"
import style0 from "./orderEvaluateDetail.vue?vue&type=style&index=0&id=1c601da4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c601da4",
  null
  
)

export default component.exports